import { memo } from 'react';

import { TableWithActions } from '..';
import { useLogic } from './logic';
import { IProps } from './type';

const ContractedKoreanBusinessComponent = (props: IProps) => {
	const {
		columns,
		fetching,
		contractedKoreanBusiness,
		handlePageChange,
		handlePageSizeChange,
		total,
		reduxParams,
		t,
	} = useLogic(props);
	return (
		<div className="bg-white rounded-2xl">
			<TableWithActions
				columns={columns}
				dataSource={contractedKoreanBusiness}
				titleInDetail={t('contractedKorean:title')}
				actionHidden
				loading={fetching}
				rowKey="id"
				actionsTop
				onPageChange={handlePageChange}
				onPageSizeChange={handlePageSizeChange}
				pagination={{
					defaultPageSize: reduxParams?.pageSize,
					current: reduxParams?.page,
					pageSize: reduxParams?.pageSize,
					total,
				}}
				defaultPageSize={reduxParams?.pageSize}
			/>
		</div>
	);
};

export const ContractedKoreanBusiness = memo(ContractedKoreanBusinessComponent);
